var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"ma-0 pa-0",attrs:{"hide-details":"","label":_vm.$t('assemblyPlanning.trialPlans')},model:{value:(_vm.trial),callback:function ($$v) {_vm.trial=$$v},expression:"trial"}})
}
var staticRenderFns = []

export { render, staticRenderFns }